export default {
  Home: {
    header: {
      hello_user: 'Olá {0}, seja bem vindo(a) à',
      edit_farm: 'Editar fazenda',
      enable_farm: 'Habilitar fazenda',
      sown_area: 'Área semeada',
      enable_farm_successfully: 'Fazenda habilitada com sucesso.',
      she_disabled: 'Desabilitada',
    },
    header_no_farms: {
      welcome_no_farms: 'Você ainda não possui nenhuma fazenda cadastrada',
      manual_create_farm: 'Cadastrar sua fazenda manualmente',
      create_farm: 'Cadastrar sua fazenda',
    },
    quick_actions: {
      quick_actions: 'ações rápidas',
      see_catalog: 'ver catálogo',
      plan_fungicide: 'planejar fungicida',
      create_note: 'criar anotação',
      see_fields: 'ver talhões',
      register_sowing: 'registrar semeadura',
    },
    item_list: {
      fields: 'talhões',
      see_all: 'ver todos',
      active_sowings: 'semeaduras ativas',
      sowings: 'semeaduras',
    },
    sowing: {
      next_spray: 'Próxima Aplicação',
      complete: 'completo',
      not_current_season:
        'A semeadura não é desta safra. Não é possível editá-la',
    },
    current_season_displayer: {
      season: 'Safra',
    },
  },
}
